export const TITLE_STATE_MODEL_DEFAULTS = {
    title: null,
    titleQueryParams: {},
    related: [],
    metaTags: [],

    // whether some title operation is being performed
    // currently (for example, video being deleted)
    loading: false,

    // currently active title or episode videos
    videos: [],
};
